<template>
  <div v-if="content && review">
    <div class="d-flex flex-column">
      <div class="d-flex flex-row align-items-center">
        <div class="row g-0 align-self-center align-items-center justify-content-center">
          <div class="cta-3 text-primary">Réponse en cours de rédaction</div>
        </div>

        <button
            v-if="context.email_action"
            :class="{'btn-success': hasSentEmail, 'btn-outline-primary': !hasSentEmail}"
            type="button"
            class="btn btn-sm btn-icon btn-icon-only ms-1 ms-auto"
            data-bs-toggle="modal"
            :data-bs-target="'#note-modal' + content.uid"
        >
          <i class="bi-app-indicator"></i>
        </button>

        <div class="dropdown is-right" :class="{'is-active': show_signature}">
          <div class="dropdown-trigger">
            <button
                v-if="review.establishment.signature_set.length"
                ref="sigTrigger"
                type="button"
                class="btn btn-outline-primary btn-sm btn-icon btn-icon-only ms-1"
                :disabled="!context.active"
                @click="show_signature = !show_signature"
            >
              S
            </button>
          </div>

          <div class="dropdown-menu" aria-labelledby="btnGroupDrop3">
            <a
                v-for="(s, index) in review.establishment.signature_set"
                :key="index"
                class="dropdown-item"
                href="#"
                @click.prevent="copysig(s)"
            >
              <b>{{ s.language.code }} - {{ s.title }}</b>
              <p style="white-space: pre-wrap">{{ s.content }}</p>
            </a>
          </div>
        </div>

        <button
            v-if="can_delete"
            @click="delete_state"
            type="button"
            class="btn btn-outline-primary btn-sm btn-icon btn-icon-only ms-1"
        >
          <i class="bi-trash"></i>
        </button>
      </div>

      <div class="text-alternate">{{ human_created_on }}</div>

      <form class="row gx-3 gy-2 align-items-center d-flex align-items-center mb-2 mt-2">
        <label class="label" v-if="review.native_lang.code !== 'FR'">
          Réponse en français
        </label>
        <div class="input-group">
          <textarea
              class="form-control"
              placeholder="Texte de la réponse"
              id="answer_fr"
              style="resize: both;"
              ref="answer_fr"
              v-model="content.data.text_fr"
              :readonly="!context.active"
              rows="8"
              :id="'review_state_answer_writing_textarea_answer_fr_' + $store.state.selected_review_uid"
          ></textarea>
          <BaseButton
              id="button-area"
              :type="content.data.text_fr === '' ? 'danger' : 'primary'"
              outline
              @click="saveAnswer()"
              :disabled="isAnswerFrDisabled"
          >
            Enregistrer
          </BaseButton>

        </div>
        <div class="btn-group" v-if="review.native_lang.code !== 'FR'">
          <button
              class="btn btn-outline-primary btn-sm"
              style="margin-left: 0.5em; flex-basis: fit-content;"
              type="button"
              @click="translateWithDeepL('EN-GB')"
              :disabled="!content.data.text_fr || isTranslating"
          >
          <span v-if="isTranslating">
            <span class="spinner-border spinner-border-sm me-1" role="status"></span>
            Traduction...
          </span>
            <span v-else>Traduire en anglais</span>
          </button>
          <button
              class="btn btn-outline-primary btn-sm"
              style="margin-left: 0.5em; flex-basis: fit-content;"
              type="button"
              @click="translateWithDeepL(review.native_lang.code)"
              :disabled="!content.data.text_fr || isTranslating"
          >
          <span v-if="isTranslating">
            <span class="spinner-border spinner-border-sm me-1" role="status"></span>
            Traduction...
          </span>
            <span v-else>Traduire en langue originale</span>
          </button>
          <a
              class="btn btn-outline-primary btn-sm"
              style="margin-left: 0.5em; flex-basis: fit-content;"
              :href="deeple_translate_link"
              target="_blank"
              :disabled="!content.data.text_fr"
          >
            <span>Ouvrir dans deepl</span>
          </a>
        </div>

        <label class="label" v-if="review.native_lang.code !== 'FR'">
          Réponse traduite
        </label>
        <div class="input-group" v-if="review.native_lang.code !== 'FR'">
          <textarea
              class="form-control"
              placeholder="Texte de la réponse"
              id="answer_native"
              style="resize: both;"
              ref="answer_native"
              v-model="content.data.text_native"
              :readonly="!context.active"
              rows="8"
              :id="'review_state_answer_writing_textarea_answer_native_' + $store.state.selected_review_uid"
          ></textarea>
          <BaseButton
              id="button-area"
              :type="content.data.text_native === '' ? 'danger' : 'primary'"
              type-button="button"
              outline
              @click="saveAnswer()"
              :disabled="isAnswerNativeDisabled"
          >
            Enregistrer
          </BaseButton>

        </div>
      </form>

      <StateComments
          :comments="content.data.comments"
          :active="context.active"
          @comments:added="update_data"
          @comments:updated="update_data"
      />
    </div>
  </div>
</template>

<script>
import settings from "@/settings";
import tools from "@/tools.js";
import StateComments from "@/components/StateComments.vue";
import BaseButton from "@/components/ui/BaseButton.vue";
import moment from "moment";

moment.locale("fr");

export default {
  name: "StateAnswerWriting",
  components: {
    BaseButton,
    StateComments
  },
  props: {
    context: {type: Object, required: true},
    can_delete: Boolean,
    email_set: Array,
    review: Object
  },
  data() {
    return {
      content: null,
      show_signature: false,
      isDirty: false,
      isTranslating: false
    };
  },
  computed: {
    deeple_translate_link() {
      let text = this.content.data.text_fr || "";
      return `https://www.deepl.com/translator#fr/en-gb/${encodeURIComponent(
          text.replace(/&/g, " ").replace(/\//g, "∕")
      )}`;
    },
    isAnswerFrDisabled() {
      return (
          !this.context.active ||
          !this.content ||
          !this.content.data ||
          this.content.data.text_fr === null ||
          this.content.data.text_fr === ''
      );
    },
    isAnswerNativeDisabled() {
      return (
          !this.context.active ||
          !this.content ||
          !this.content.data ||
          this.content.data.text_native === null ||
          this.content.data.text_native === ''
      );
    },
    human_created_on() {
      return moment(this.context.created_on).fromNow();
    },
    hasSentEmail() {
      return this.email_set.length > 0 && this.email_set.some(e => e.sent_on);
    }
  },
  methods: {
    async translateWithDeepL(lang) {
      if (!this.content.data.text_fr || this.isTranslating) return;

      this.isTranslating = true;

      try {
        const response = await this.$http.post(
            settings.backendUrl + "/admin/api/translate_deepl",
            {
              text: this.content.data.text_fr,
              target_lang: lang
            },
            {headers: {'Content-Type': 'application/json'}}
        );

        if (!response.ok) {
          throw new Error(`Translation error: ${response.status}`);
        }

        const data = await response.json();
        this.content.data.text_native = data.translations[0].text;

        this.$store.dispatch("notify", {
          level: "success",
          text: "Traduction réussie!",
          seconds: 3
        });
      } catch (error) {
        console.error('Translation error:', error);
        this.$store.dispatch("notify", {
          level: "danger",
          text: "Erreur lors de la traduction",
          seconds: 5
        });
      } finally {
        this.isTranslating = false;
      }
    },
    delete_state() {
      this.$emit("state:delete_state");
    },
    update_data(comments) {
      this.content.data.comments = comments;
      this.$emit("state:update_data", this.content.data);
    },
    saveAnswer() {
      this.$emit("state:update_data", this.content.data);
      this.$store.commit("delete_edited_fields", {key: "text_native"});
      this.$store.commit("delete_edited_fields", {key: "text_fr"});
      this.isDirty = false;
    },
    set_answer_content(value) {
      this.content.data.text_fr = value;
    },
    copysig(signature) {
      if (signature.language.code === "FR") {
        this.content.data.text_fr = (this.content.data.text_fr || "") + "\n\n" + signature.content;
        this.copySignature(signature);
      } else if (this.review.native_lang.code === "FR") {
        this.$store.dispatch("notify", {
          level: "danger",
          text: "Echec de la copie, cet avis est en français",
          seconds: 5
        });
      } else {
        this.content.data.text_native = (this.content.data.text_native || "") + "\n\n" + signature.content;
        this.copySignature(signature);
      }
    },
    copySignature(signature) {
      const textArea = document.createElement("textarea");
      textArea.value = signature.content;
      textArea.style.position = "fixed";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      this.$store.dispatch("notify", {
        level: "success",
        text: "Copié!",
        seconds: 2
      });
    },
    closeListener(e) {
      if (this.$refs.sigTrigger !== e.target) {
        this.show_signature = false;
      }
    },
    preventLoss(event) {
      if (this.isDirty) {
        event.preventDefault();
        event.returnValue = "Vous avez des modifications non sauvegardées. Voulez-vous vraiment quitter ?";
        return event.returnValue;
      }
    }
  },
  mounted() {
    window.addEventListener("beforeunload", this.preventLoss);
    this.$root.state_set_answer_content = this.set_answer_content;
    document.addEventListener("click", this.closeListener, true);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.preventLoss);
    document.removeEventListener("click", this.closeListener, true);
  },
  created() {
    this.content = tools.deep_copy(this.context);
    this.$djangows.onmodelsignals(
        {modelName: "state", appLabel: "state"},
        event => {
          if (event.obj.uid === this.content.uid && event.signal_type === "post_save" && !event.created) {
            this.content.data.comments = event.obj.data.comments;
          }
        }
    );
  },
  watch: {
    "content.data.text_native": function (newV, oldV) {
      if (newV !== oldV && oldV !== undefined) {
        this.$store.commit("update_edited_fields", {
          key: "text_native",
          value: newV,
          verbose_name: "Réponse traduite",
          el: this.$refs.answer_native
        });
        this.isDirty = true;
      }
    },
    "content.data.text_fr": function (newV, oldV) {
      if (newV !== oldV && oldV !== undefined) {
        this.$store.commit("update_edited_fields", {
          key: "text_fr",
          value: newV,
          verbose_name: "Réponse en français",
          el: this.$refs.answer_fr
        });
        this.isDirty = true;
      }
    }
  }
};
</script>

<style scoped lang="scss">
textarea {
  /* font-family: "Nunito Sans", sans-serif; */
  resize: both;
}
.dropdown-menu {
  max-height: 300px;
  overflow-y: auto;
}
</style>
